import React, { Component } from 'react';
import styled from 'styled-components';

import { PRIMARY } from '../constants/colors';

const Progress = styled.div`
  width: ${(props) => props.width}%;
  height: 20px;
  border-radius: 3px;
  background-color: ${PRIMARY};
  display: block;
`;

export class ProgressBar extends Component {
  render() {
    return (
      <div style={{width: '100%'}}>
        <span>
          {`${this.props.progress}%`}
        </span>
        <Progress width={this.props.progress} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js